export default __webpack_public_path__ + "static/media/bootstrapback.e80558dd.svg";